var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgParking(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 49,
    viewBox: "0 0 45 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_10228_960)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.25 1L6.25 23.7579L1.25 48",
    stroke: "#555555",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.25 1L3.25 23.7579L8.25 48",
    stroke: "#555555",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.25 1L39.25 23.7579L44.25 48",
    stroke: "#555555",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.25 1L42.25 23.7579L37.25 48",
    stroke: "#555555",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.75 23.5H3.25H41.75",
    stroke: "#555555",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.25 48H44.25",
    stroke: "#555555",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.25 1H44.25",
    stroke: "#555555",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.3358 16.5H12.25L11.75 18.5H16.3358C17.2267 18.5 17.6729 17.4229 17.0429 16.7929C16.8554 16.6054 16.601 16.5 16.3358 16.5Z",
    fill: "#ECBE08"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.1642 16.5H32.25L32.75 18.5H28.1642C27.2733 18.5 26.8271 17.4229 27.4571 16.7929C27.6446 16.6054 27.899 16.5 28.1642 16.5Z",
    fill: "#ECBE08"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.75 20.5H14.75V22.5C14.75 23.0523 14.3023 23.5 13.75 23.5C13.1977 23.5 12.75 23.0523 12.75 22.5V20.5Z",
    stroke: "#555555"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.75 20.5H31.75V22.5C31.75 23.0523 31.3023 23.5 30.75 23.5C30.1977 23.5 29.75 23.0523 29.75 22.5V20.5Z",
    stroke: "#555555"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.1067 15.7515L11.2994 18.577C11.0241 19.5407 11.7477 20.5 12.75 20.5H31.75C32.7523 20.5 33.4759 19.5407 33.2006 18.577L32.3933 15.7515C32.0125 14.4188 30.7944 13.5 29.4084 13.5H15.0916C13.7056 13.5 12.4875 14.4188 12.1067 15.7515Z",
    stroke: "#555555",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.75 13.5H16.75H27.75H29.75L27.35 10.3C26.9723 9.79639 26.3795 9.5 25.75 9.5H18.75C18.1205 9.5 17.5277 9.79639 17.15 10.3L14.75 13.5Z",
    stroke: "#555555",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.75 20.5L19.5606 17.2575C19.6719 16.8123 20.0719 16.5 20.5308 16.5H23.557C23.9738 16.5 24.347 16.7586 24.4933 17.1489L25.75 20.5",
    stroke: "#555555",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_10228_960"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 45,
    height: 49,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgParking);
export default __webpack_public_path__ + "static/media/Parking.8e5bd0511b01d09f979592d96d56ab85.svg";
export { ForwardRef as ReactComponent };